// extracted by mini-css-extract-plugin
export default {"botProtectionInfo":"NftLeftInfoEditionInfo_botProtectionInfo__rZyJ4","rows":"NftLeftInfoEditionInfo_rows__U7bGp"};